import React from 'react';
import type { ControllerProps } from 'react-hook-form/dist/types';
import { ControlledInputField } from 'components/controlled-input-field';
import type { PropertyFormValues } from 'features/my-zone/support-requests/components/support-requests-modals/modals/request-new-location/request-property/types';
import { US_ZIP_CODE_REGEX } from 'features/my-zone/support-requests/consts';
import styles from './controlled-property-form.module.scss';

export type ControlledPropertyFormProps = Omit<
    ControllerProps<PropertyFormValues>,
    'render' | 'name'
> & {
    index: number;
};

export const ControlledPropertyForm = ({ control, index }: ControlledPropertyFormProps) => {
    return (
        <>
            <div className={styles.inputWrapper}>
                <ControlledInputField
                    testId={`property-${index}-name`}
                    placeholder="Property name"
                    control={control}
                    name={`properties.${index}.name`}
                    rules={{
                        required: { value: true, message: 'This field is required' },
                    }}
                />
            </div>
            <div className={styles.inputWrapper}>
                <ControlledInputField
                    testId={`property-${index}-address`}
                    placeholder="Street, City, State"
                    control={control}
                    name={`properties.${index}.address`}
                    rules={{
                        required: { value: true, message: 'This field is required' },
                    }}
                />
            </div>
            <div className={styles.inputWrapper}>
                <ControlledInputField
                    testId={`property-${index}-zip_code`}
                    placeholder="Property Zip code (Optional)"
                    control={control}
                    name={`properties.${index}.zip_code`}
                    maxLength={15}
                    rules={{
                        pattern: {
                            value: US_ZIP_CODE_REGEX,
                            message: 'Invalid zip code',
                        },
                    }}
                />
            </div>
        </>
    );
};
